<template>
  <v-card class="mt-n7" elevation="0">
    <v-card elevation="2" class="my-4 mx-4">
      <v-card-text>
            <v-divider inset></v-divider>

        <v-row>
          <v-col cols="12" sm="6">
            <div class="mt-5" v-if="role != 'secacu' && (cuenta && cuenta.status >= 43)">
              <div>

                 <p class="text-h6 grey--text"> <u>SENTIDO</u> </p>

              </div>
              <div class="mt-4 mb-4" style="color: green;">
                <div v-if="cuenta.sentido_ponencia_id == cuenta.sentido_colegiada_id">
                  Aprobado El Sentido de Ponencia<br>
                  {{ cuenta.sentido_ponencia }}
                </div>
                <div v-else>
                  Se Modificó el Sentido de Ponencia<br>
                  <b>Ponencia:</b> {{ cuenta.sentido_ponencia }}<br>
                  <b>Sentido Final:</b> {{ cuenta.sentido_colegiada }}
                </div>
              </div>
              <v-divider></v-divider>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import Sentido from "@/components/Sentido";
  export default {
    // components: {
    //   Sentido
    // },
    props: {
      apelacion: {
        type: Object,
        required: true
      },
      cuenta: {
        type: Object,
        required: false
      },
      role: {
        type: String,
        required: true
      }
    },
    data: () => ({
      active_tab: {},
      archivar_toca: false,
    }),
    computed: {
      ...mapGetters([ "currentUser", "getAllPonencias" ])
    },
    mounted(){
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.active_tab = this.$route.params
      if (this.cuenta && this.cuenta.colegiada) {
        this.resultado = this.apelacion.documentos.find( doc =>
          doc.categoria_id === 3 && doc.url_evidencia != null
        );
        if (this.resultado) {
          this.archivar_toca = true
        }
      }
    },
    methods:{

    }
  };
</script>